import * as swcHelpers from '@swc/helpers';
import { isNumber } from '@grandvisionhq/utils';

const getFramesDisplayPrice = (variantPrice, offering, sspTotalPrice)=>{
    var ref, ref1;
    const updatedPrice = {
        originalPrice: variantPrice.originalPrice,
        discountedPrice: variantPrice === null || variantPrice === void 0 ? void 0 : variantPrice.discountedPrice,
        currency: variantPrice.currency,
        isCentAmount: variantPrice.isCentAmount
    };
    if ((offering === null || offering === void 0 ? void 0 : (ref = offering.originalPriceInformation) === null || ref === void 0 ? void 0 : ref.amount) && isNumber(sspTotalPrice)) {
        console.error('Offering and SSP price are not supposed to be available at the same time. This is an unhandled situation.');
    }
    if (isNumber(sspTotalPrice)) {
        updatedPrice.originalPrice = sspTotalPrice;
        /**
     * When the product doesn't have a discounted price, we want to keep it that way.
     * If the (total) discounted price returned from here is a number (even 0), it will
     * show up on the PDP. So we want to keep it undefined.
     */ const nonFrameSSPPrice = sspTotalPrice - updatedPrice.originalPrice;
        updatedPrice.discountedPrice = updatedPrice.discountedPrice ? updatedPrice.discountedPrice + nonFrameSSPPrice : undefined;
        return updatedPrice;
    }
    if (offering === null || offering === void 0 ? void 0 : (ref1 = offering.originalPriceInformation) === null || ref1 === void 0 ? void 0 : ref1.amount) {
        var ref2;
        const offeringOriginalPrice = offering.originalPriceInformation.amount;
        const offeringDiscountPrice = (ref2 = offering.discountedPriceInformation) === null || ref2 === void 0 ? void 0 : ref2.amount;
        if (offeringDiscountPrice) {
            if (updatedPrice.discountedPrice) {
                // -- Variant AND Offering with discount --
                updatedPrice.discountedPrice += offeringDiscountPrice;
            } else {
                //-- Only Offering with discount --
                updatedPrice.discountedPrice = updatedPrice.originalPrice + offeringDiscountPrice;
            }
        } else if (updatedPrice.discountedPrice) {
            //-- Only Variant with discount --
            updatedPrice.discountedPrice += offeringOriginalPrice;
        }
        updatedPrice.originalPrice += offeringOriginalPrice;
    }
    return swcHelpers.objectSpread({}, variantPrice, updatedPrice);
};

export { getFramesDisplayPrice };
//# sourceMappingURL=get-frames-display-price.js.map
